import { createSelector } from "reselect";

import { getFilters } from "./state-accessors";

export const getSelectedVehicleType = createSelector(
  getFilters,
  filters => filters.vehicle_type
);
